import crud from "./_crud";
import { callApi } from 'utils/api'
import { showErrorMessage, showSuccessMessage } from 'utils/messages'

const actions = crud('unit_measure', 'la unidad de medida', 'las unidades de medidas');

const importUnitsMeasures = (options) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/unit_measure/import_units_measures`, {
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify({
				options,
			}),
			successMessage: `Se agreron las unidades de medida correctamente.`,
		})
		showSuccessMessage('Se registraron las unidades de medida correctamente')
		return res.body
	}
}

export default {...actions, importUnitsMeasures}